"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var GlobalStyle_1 = require("../styles/GlobalStyle");
var NoFocusOutline_1 = require("../styles/NoFocusOutline");
require("../styles/resetr.css");
var theme_1 = require("./theme");
var ThemeProvider = function (_a) {
    var children = _a.children, theme = _a.theme;
    var _b = (0, react_1.useState)(true), noFocusOutline = _b[0], setNoFocusOutline = _b[1];
    var mergedTheme = __assign(__assign({}, theme_1.theme), theme);
    var a11yHandler = function (_a) {
        var keyCode = _a.keyCode;
        // Add focus outline when tab key is pressed
        if (keyCode === 9) {
            setNoFocusOutline(false);
        }
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener("keydown", a11yHandler);
        window.addEventListener("keyup", a11yHandler);
        return function () {
            window.removeEventListener("keydown", a11yHandler);
            window.removeEventListener("keyup", a11yHandler);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(styled_components_1.ThemeProvider, { theme: mergedTheme, children: [(0, jsx_runtime_1.jsx)(GlobalStyle_1.GlobalStyle, { theme: mergedTheme }), (0, jsx_runtime_1.jsx)(NoFocusOutline_1.NoFocusOutline, { noFocusOutline: noFocusOutline }), children] }));
};
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map